import styled from "@emotion/styled";
import {Tooltip} from "@blueprintjs/core";
import {NestedJobStop} from "../../../generated/graphql";
import StopInfo, {StopInfoMetadata} from "../../map/stop/StopInfo";
import StopDot from "./StopDot";

export type StopPinProps = {
  lat: number;
  lng: number;
  stop: NestedJobStop;
  info: StopInfoMetadata;
  color: string;
  newWindow?: Window;
  usePortal?: boolean;
};

export const StopPin = ({stop, info, color, newWindow, usePortal}: StopPinProps) => (
  <Tooltip
    content={<StopInfo info={info} stop={stop} color={color} />}
    placement="top"
    popoverClassName="marker-popover"
    usePortal={usePortal}
    portalContainer={newWindow?.document.body}
  >
    <StopPinWrapper data-testid="stop-pin-wrapper" data-color={color}>
      <StopDot color={color} />
    </StopPinWrapper>
  </Tooltip>
);

export const StopPinWrapper = styled.div`
  cursor: pointer;
`;
